import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Prebuilt Font Awesome CSS — Vite resolves and bundles the bundled webfonts,
// so no manual copying into public/ is needed.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './scss/index.scss';
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// PWA: register the service worker in production builds only, so the Vite dev
// server (HMR) and the E2E suite always run against fresh, uncached code.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* offline shell is a progressive enhancement — the app works without it */
    });
  });
}
